document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-brand-toggle').forEach(button => {
    const text = button.previousElementSibling;

    if (!text) return;

    button.addEventListener('click', () => {
      const isOpen = text.classList.toggle('full');

      button.textContent = isOpen ? 'Lire moins' : 'Lire la suite';
    });
  });
});
